module.exports = __webpack_public_path__ + "static/gatku-3-f6e9bfabec04075461d7e3c4ac8077eb.jpg";